import { AbsProduct, HycProduct, IgcProduct } from '@/creditflowresearch/domain/Product';
import productColors from '@/creditflowresearch/ui/common/styles/productColors';

export const PRODUCT_COLORS = {
  [AbsProduct.ABBREVIATION]: productColors.colorProductAbs,
  [HycProduct.ABBREVIATION]: productColors.colorProductHyc,
  [IgcProduct.ABBREVIATION]: productColors.colorProductIgc,
} as const;

export const PRODUCT_GRADIENTS = {
  [AbsProduct.ABBREVIATION]: productColors.gradientProductAbs,
  [HycProduct.ABBREVIATION]: productColors.gradientProductHyc,
  [IgcProduct.ABBREVIATION]: productColors.gradientProductIgc,
  [HycProduct.ABBREVIATION + IgcProduct.ABBREVIATION]: productColors.gradientProductHycIgc,
} as const;

export interface IProductCombination {
  requiredAbbreviations: string[],
  gradientKey: string,
  priority: number,
}

export const CORPORATE_PRODUCTS = [
  HycProduct.ABBREVIATION,
  IgcProduct.ABBREVIATION,
] as const;

const isCorporateProduct = (abbreviation: string): boolean => {
  return abbreviation === HycProduct.ABBREVIATION || abbreviation === IgcProduct.ABBREVIATION;
};

const isNonCorporateProduct = (abbreviation: string): boolean => {
  return abbreviation === AbsProduct.ABBREVIATION;
};

export const prioritizeProductAbbreviations = (
  abbreviations: string[],
): string[] => {
  const hasNonCorporate = abbreviations.some(isNonCorporateProduct);
  const hasCorporate = abbreviations.some(isCorporateProduct);

  if (hasNonCorporate && hasCorporate) {
    return [AbsProduct.ABBREVIATION];
  }

  return abbreviations;
};

export const PRODUCT_COMBINATIONS: IProductCombination[] = [
  {
    requiredAbbreviations: [HycProduct.ABBREVIATION, IgcProduct.ABBREVIATION],
    gradientKey: HycProduct.ABBREVIATION + IgcProduct.ABBREVIATION,
    priority: 1,
  },
];

export const findMatchingCombination = (
  abbreviations: string[],
): IProductCombination | null => {
  const matchingCombinations = PRODUCT_COMBINATIONS.filter((combination) =>
    combination.requiredAbbreviations.every((abbr) => abbreviations.includes(abbr)),
  );

  if (matchingCombinations.length === 0) {
    return null;
  }

  return matchingCombinations.reduce((highest, current) =>
    current.priority > highest.priority ? current : highest,
  );
};

export const getProductColor = (abbreviation: string): string => {
  return PRODUCT_COLORS[abbreviation] || '';
};

export const getProductGradient = (abbreviation: string, fallback = ''): string => {
  return PRODUCT_GRADIENTS[abbreviation] || fallback;
};
